module.exports = __webpack_public_path__ + "img/DE00091.0838e5f6.png";